import Head from 'next/head';
import Articles from '../../components/layout/articles';
import styles from '../../styles/sass/pages/BlogHome.module.scss';

const API_BASE_URL = process.env.API_BASE_URL || '';
const PUBLIC_API_KEY = process.env.PUBLIC_API_KEY || '';
const ARTICLE_REVALIDATE = process.env.ARTICLE_REVALIDATE || 43200;

export default function Blog({ articles }) {

    return (
        <>
            <Head>
                <title>Blog | Szabó Jennifer Pszichológus</title>
                <meta name="description" content="Pszichilógiai cikkek, önismereti anyagok, könyvajánlók, gyakorlatok egy helyen." />
                <meta property="og:title" content="Blog | Szabó Jennifer Pszichológus" />
                <meta property="og:type" content="article" />
                <meta property="og:description" content="Pszichilógiai cikkek, önismereti anyagok, könyvajánlók, 
                gyakorlatok egy helyen." />
                <meta property="og:url" content="https://szabojennifer.hu/szolgaltatasok/szemelyes-tanacsadas" />
                <meta property="og:image" content="/img/szolgaltatasok/szemelyes-tanacsadas-hero.png" />
                <meta property="og:image:alt" content="Pszichológiai tanácsadás közben jegyzetelő kéz" />
            </Head>
            <div className={styles.container}>
                <Articles
                    title='A BLOG'
                    articles={articles}
                />
            </div>
        </>
    )
}

export async function getStaticProps() {
    try {
        const res = await fetch(API_BASE_URL + '/articles', {
            next: { revalidate: ARTICLE_REVALIDATE },
            headers: { 'Api-Key': PUBLIC_API_KEY },
        });
        if (!res || !res.ok) {
            return { props: {} };
        }
        const articles = await res.json();
        console.log('articles:', articles);
        return {
            props: { articles },
            // Next.js will attempt to re-generate the page:
            // - When a request comes in
            // - At most once every 180 seconds
            revalidate: 180,
        };
    } catch (error) {
        return { props: {} };
    }
}